import React from 'react';
import styled from 'styled-components';

const P = styled.p`
	margin-top: 10px;
`;

const PurpleText = styled.span`
	color: ${props => props.theme.purple};
`;

const About = () => {
	return(
		<div className="about__content">
			<h2>bantu<PurpleText>in</PurpleText></h2>
			<P>Sebuah alat untuk mencari pengalaman serta memamerkan bakat anda kepada dunia.</P>
		</div>
	);
}

export default About;